import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { contactInfo } from '@/mocks/about';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 py-14">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-2-line text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-semibold text-background-50 whitespace-nowrap" style={{ fontFamily: 'var(--font-heading)' }}>
                秘密教学
              </span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed">
              解锁隐藏知识的高效学习法。揭示课堂之外、教科书背后的核心学习方法，帮助每一位学习者突破常规。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">学习分类</h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-background-50 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-400 hover:text-background-50 transition-colors">首页</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-background-50 transition-colors">关于我们</Link>
              </li>
              <li>
                <a href="#faq" className="text-sm text-foreground-400 hover:text-background-50 transition-colors">常见问题</a>
              </li>
              <li>
                <a href="#contact" className="text-sm text-foreground-400 hover:text-background-50 transition-colors">联系我们</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系方式</h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-mail-line"></i>
                <span>{contactInfo.email}</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-wechat-line"></i>
                <span>{contactInfo.wechat}</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-map-pin-line"></i>
                <span>{contactInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 秘密教学. 保留所有权利.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors" rel="nofollow">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}